import { StateCreator } from 'zustand';

import {
  BrainRecentPagesSlice,
  BrainStore,
  INITIAL_BRAIN_STATE,
} from '../types';

export const createRecentPagesSlice: StateCreator<
  BrainStore,
  [],
  [],
  BrainRecentPagesSlice
> = (set) => ({
  recentPages: INITIAL_BRAIN_STATE.recentPages,
  isLoadingRecentPages: INITIAL_BRAIN_STATE.isLoadingRecentPages,
  recentPagesStale: INITIAL_BRAIN_STATE.recentPagesStale,

  setRecentPages: (pages) => {
    set({ recentPages: pages, isLoadingRecentPages: false });
  },

  setLoadingRecentPages: (loading) => {
    set({ isLoadingRecentPages: loading });
  },

  markRecentPagesStale: () => {
    set({ recentPagesStale: true });
  },

  clearRecentPagesStale: () => {
    set({ recentPagesStale: false });
  },
});
